export default __webpack_public_path__ + "assets/images/2f0a0fa39587e694c69b59c498ccbea6.png";